import { useTranslation } from "react-i18next";
import BrandMark from "@/components/BrandMark/BrandMark";
import "@/components/SiteFooter/SiteFooter.scss";

function SiteFooter() {
  const { t } = useTranslation();

  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <BrandMark inverted />
          <p>{t("footer.tagline")}</p>
        </div>
        <p className="site-footer__legal">
          {t("footer.legal", { year: new Date().getFullYear() })}
        </p>
      </div>
    </footer>
  );
}

export default SiteFooter;
